window.addEventListener('DOMContentLoaded', () => {
  if (document.querySelectorAll('.dsgvo-youtube').length) {
    import('./_dsgvo-youtube').then((module) => {
      module.Init();
    });
  }
});

export default {}